import { render, staticRenderFns } from "./StockItemsUsedDetails.vue?vue&type=template&id=71f3e2f6&"
import script from "./StockItemsUsedDetails.vue?vue&type=script&lang=js&"
export * from "./StockItemsUsedDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports